/**
 * Komal OS - KRA External Input Store
 * Powers the Cross-Department Input Queue screen
 */

import { create } from 'zustand';
import * as kraExternalInputService from '../services/kraExternalInputService';

const useKraExternalInputStore = create((set, get) => ({
  queue: [],
  total: 0,
  isLoading: false,
  isSubmitting: false,
  error: null,

  clearError: () => set({ error: null }),

  fetchQueue: async (departmentId) => {
    set({ isLoading: true, error: null });
    try {
      const response = await kraExternalInputService.getExternalInputQueue(departmentId);
      set({ queue: response.data.queue || [], total: response.data.total || 0, isLoading: false });
      return response.data.queue;
    } catch (error) {
      const message = error.response?.data?.detail || 'Failed to load the input queue';
      set({ error: message, isLoading: false });
      return [];
    }
  },

  submitInput: async (cycleId, data) => {
    set({ isSubmitting: true, error: null });
    try {
      const response = await kraExternalInputService.submitExternalInput(cycleId, data);
      await get().fetchQueue();
      set({ isSubmitting: false });
      return { success: true, data: response.data };
    } catch (error) {
      const message = error.response?.data?.detail || 'Failed to submit input';
      set({ error: message, isSubmitting: false });
      return { success: false, error: message };
    }
  },
}));

export default useKraExternalInputStore;
